import PropTypes from "prop-types";
import BaseComponent from "./BaseComponent";
import VerticalLayout from "./layouts/VerticalLayout";
import HorizontalLayout from "./layouts/HorizontalLayout";
import T from "../../appl/model/system/text_translations/Translator";
import {createRef} from "react";
import UploadManager from "../../appl/model/system/UploadManager";
import ProgressBar from "./progressBar/ProgressBar";
import Put from "../model/service/resource/dto/Put";
import GF from "../utils/GF";
import {Dropzone} from "react-dropzone"; // Nur für Types, siehe unten für Drag-Handling

class Upload extends BaseComponent {
  constructor(props) {
    super(props);
    this.inputField = createRef();
    this.progressBarContainerRef = createRef();
    this.labelContainer = createRef();
    this.dropRef = createRef();

    this.state = {
      importId: GF.getValue(this.props.importId, ''),
      progress: 0,
      isDragActive: false,
    };

    this.handleDrop = this.handleDrop.bind(this);
    this.handleDragOver = this.handleDragOver.bind(this);
    this.handleDragLeave = this.handleDragLeave.bind(this);
  }

  handleDragOver(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!this.state.isDragActive) {
      this.setState({isDragActive: true});
    }
  }

  handleDragLeave(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({isDragActive: false});
  }

  handleDrop(e) {
    e.preventDefault();
    e.stopPropagation();
    const files = Array.from(e.dataTransfer.files);
    this.setState({isDragActive: false});
    this.uploadFiles(files);
  }

  async inputOnChange(e) {
    const files = Array.from(e.target.files);
    this.uploadFiles(files);
  }

  uploadFiles(files) {
    const uploadManager = new UploadManager();
    const dtoPut = new Put(this.state.importId);

    if (GF.checkNotNull(this.props.dtoProperties)) {
      dtoPut.setProperties(this.props.dtoProperties);
    }

    uploadManager.upload(
        dtoPut,
        files,
        (response) => {
          if (!this.props.hideProgress) {
            this.setState({progress: 100});
          }
          this.onUploadDone(response);
        },
        (progress) => {
          if (!this.props.hideProgress) {
            this.setState({progress});
          }
        }
    );
  }

  setImportId(importId) {
    this.setState({importId});
  }

  onUploadDone(response) {
    if (GF.checkNotNull(this.props.onUploadDone)) {
      this.props.onUploadDone(response);
    }
  }

  render() {
    const {isDragActive, progress} = this.state;
    const uploadHint = this.props.uploadArea || (
        <div
            className={`p-3 md:p-10 text-wrap text-center ${
                isDragActive ? 'bg-cn-color-primary text-white' : 'bg-cn-color-black'
            }`}
            ref={this.labelContainer}
        >
          {isDragActive ? 'Dateien hier ablegen …' : T.component_upload_hint()}
        </div>
    );

    const progressBar =
        this.props.hideProgress || progress === 0 ? null : (
            <ProgressBar
                ref={this.progressBarContainerRef}
                progress={progress}
                text="Upload-Fortschritt"
            />
        );

    return (
        <VerticalLayout className={'gap-2 ' + this.props.className}>
          <HorizontalLayout className="flex-wrap justify-between">
            {this.props.title && <h3 className="pb-0">{this.props.title}</h3>}
          </HorizontalLayout>

          <div
              className="rounded border-[2px] border-dashed border-cn-color-secondary relative"
              onDrop={this.handleDrop}
              onDragOver={this.handleDragOver}
              onDragLeave={this.handleDragLeave}
          >
            <form className="relative">
              <label htmlFor={this._id?.toString()}>{uploadHint}</label>
              <input
                  ref={this.inputField}
                  id={this._id?.toString()}
                  accept={this.props.accept}
                  className="absolute invisible inset-0 h-full z-10"
                  type="file"
                  name="files[]"
                  onChange={(e) => this.inputOnChange(e)}
                  multiple
              />
            </form>
          </div>

          {progressBar}
        </VerticalLayout>
    );
  }
}

Upload.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  onUploadDone: PropTypes.func,
  dtoProperties: PropTypes.object,
  uploadArea: PropTypes.node,
  hideHint: PropTypes.bool,
  accept: PropTypes.string,
  hideProgress: PropTypes.bool,
  uploadDialogCancelled: PropTypes.func,
  importId: PropTypes.string
};

export default Upload;